import { useEffect } from 'react';
import UsersDataTable from './UsersDataTable/UsersDataTable';

function Users() {

  // #region templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Usuarios
          </h1>
        </section>
        <section>
          <UsersDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default Users;